exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll {\n  overflow: auto;\n  max-height: 400px;\n  min-height: 400px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/transactionhistory/transactionhistory.component.css
// module id = ../../../../../src/app/shared/component/transactionhistory/transactionhistory.component.css
// module chunks = main